import { render, staticRenderFns } from "./AccessibilityReportUs.vue?vue&type=template&id=5d322162&scoped=true"
import script from "./AccessibilityReportUs.vue?vue&type=script&lang=ts"
export * from "./AccessibilityReportUs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d322162",
  null
  
)

export default component.exports